export default __webpack_public_path__ + "static/media/phone-icon.b2ab4d42.svg";